import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { log } from '../../services/utils';

import styles from './table.module.css';

const TableHeader = ( {
	headerGroups,
	setTableState
} ) => {
	return (
		<div className={ styles.tableHeader }>
			{ log( '- tableHeader' ) }
			{ headerGroups.map( ( headerGroup, i ) => (
				<div
					{ ...headerGroup.getHeaderGroupProps() }
					className={ styles.tableRow }
					key={ i }
				>
					{ headerGroup.headers.map( ( column, i ) => {
						const sortedClass = column.isSorted
							? column.isSortedDesc
								? styles.sortedDesc
								: styles.sortedAsc
							: null;

						const handleSort = e => {
							const isShiftPressed = e.shiftKey;

							if ( !column.canSort ) {
								return null;
							}

							return setTableState
								? setTableState( prev => {
									const sortBy = isShiftPressed
										? prev.sortBy.filter( col => col.id !== column.id )
										: [];

									if ( column.isSorted ) {
										if ( !column.isSortedDesc ) {
											sortBy.push( {
												desc: true,
												id: column.id
											} );
										}
									} else {
										sortBy.push( {
											desc: false,
											id: column.id
										} );
									}

									return {
										...prev,
										sortBy
									};
								} )
								: column.getSortByToggleProps().onClick( e );
						};

						return (
							<div
								{ ...column.getHeaderProps( {
									...column.getSortByToggleProps(),
									onClick: handleSort
								} ) }
								className={ `${ styles.tableCell } ${ sortedClass }` }
								key={ i }
							>
								{ column.render( 'Header' ) }
								{ column.canResize
									? <div
										{ ...column.getResizerProps() }
										className={ `${ styles.resizer } ${ column.isResizing ? styles.isResizing : '' }` }
									/>
									: null
								}
							</div>
						);
					} ) }
				</div>
			) ) }
		</div>
	);
};

TableHeader.propTypes = {
	headerGroups: PropTypes.array.isRequired,
	setTableState: PropTypes.func
};

export default memo( TableHeader );
